
<div class = "privacy-area">
    <div class = "privacy-text">
        <h1>UNION NEST プライバシーポリシー</h1>
        <p>制定日：2026年7月15日</p>

        <p>
            合同会社パルグロウ（以下「当社」といいます。）は、当社が提供する「UNION NEST」（以下「本サービス」といいます。）において取得・利用する利用者および関係者の情報（個人情報を含みます。）を、個人情報の保護に関する法律その他の関係法令・ガイドラインを遵守し、適切に取り扱います。本ポリシーは、当社による情報の取扱い方針を定めるものです。
        </p>

        <hr>

        <h2>1. 事業者情報</h2>
        <ul>
            <li><strong>事業者名：</strong>合同会社パルグロウ</li>
            <li><strong>代表者：</strong>大塚芳枝</li>
            <li><strong>所在地：</strong>東京都渋谷区渋谷2丁目19番地15号 宮益坂ビルディング6F</li>
            <li><strong>連絡先：</strong><a href="mailto:support@palgrow.co.jp">support@palgrow.co.jp</a></li>
        </ul>

        <h2>2. 用語の定義</h2>
        <p>本ポリシーにおける主な用語は、次のとおりです。</p>
        <ol>
            <li><strong>「利用組織」：</strong>本サービスの利用契約を当社と締結し、本サービスを利用する労働組合その他の団体・法人</li>
            <li><strong>「利用者」：</strong>利用組織の役員・職員等で、利用組織により本サービスの利用を許諾された個人</li>
            <li><strong>「利用者データ」：</strong>利用者が本サービスに入力、登録、送信またはアップロードする情報（企画書・報告書・タグ・コメント・添付ファイル等を含みます。）</li>
            <li><strong>「非公開情報」：</strong>利用組織または利用者が本サービス上で非公開として設定した利用者データ（添付ファイルを含みます。）</li>
            <li><strong>「公開情報」：</strong>利用者データのうち、非公開情報に該当しないもの</li>
            <li><strong>「統計情報等」：</strong>利用者データを集計・分析・加工して作成される統計情報、ならびに識別情報（氏名、メールアドレス、組織名等）を含まない形での個別情報（事例情報）</li>
        </ol>

        <h2>3. 取得する情報</h2>
        <p>当社は、本サービスの提供にあたり、以下の情報を取得します。</p>
        <ol>
            <li><strong>アカウント情報：</strong>氏名、メールアドレス、所属（利用組織名・部署等）、役割（管理者/利用者等）、ログイン認証に必要な情報</li>
            <li><strong>利用組織の契約・請求情報：</strong>担当者情報、連絡先、請求先情報、契約に必要な情報</li>
            <li><strong>利用者データ：</strong>企画書・報告書・タグ・コメント・添付ファイルその他利用者が入力/アップロードする情報（内容によっては個人情報や秘密情報を含み得ます。）</li>
            <li><strong>問い合わせ・サポート情報：</strong>問い合わせ内容、やり取りの履歴、対応記録</li>
            <li><strong>利用状況・アクセスログ等：</strong>IPアドレス、端末識別子、ブラウザ情報、閲覧・操作履歴、Cookie等の識別子、エラーログ等</li>
            <li><strong>決済・支払に関する情報：</strong>請求書発行・入金確認等に必要な情報（クレジットカード情報等は決済代行会社が取得する場合があります。）</li>
        </ol>
        <p>当社は、利用者に対し、本サービス上に入力する個人情報や会社・団体の機密情報を必要最小限とし、適法な権限・同意に基づいて登録することを求めます。</p>

        <h2>4. 利用目的</h2>
        <p>当社は、取得した情報を以下の目的のために利用します。</p>
        <ol>
            <li>本サービスの提供、本人確認、ログイン認証、アカウント管理のため</li>
            <li>契約手続、利用料金の請求・決済、入金管理のため</li>
            <li>サポート対応、問い合わせ対応、連絡・通知のため</li>
            <li>本サービスの運用、保守、セキュリティ確保、障害対応、規約違反への対応のため</li>
            <li>本サービスの改善、品質向上、利用状況の分析、新機能の検討・開発のため</li>
            <li>利用者データを集計・分析・加工し、統計情報等を作成・利用するため（第5項参照）</li>
            <li>法令遵守、紛争対応、権利行使・防御、監査対応のため</li>
        </ol>

        <h2>5. 統計情報等の作成・利用（外部利用を含む）</h2>
        <ol>
            <li>当社は、利用者データを集計・分析・加工して統計情報等を作成することができます。</li>
            <li>当社は、統計情報等を、レポート、資料、セミナー等での情報発信、CLM参画組織への開示、ならびに当社の助言・分析・コンサルティングその他関連事業の提供に利用することがあります。</li>
            <li>前項に基づく外部利用において、当社は、利用組織名および個人が識別され得る情報を開示しないものとし、特定の利用組織または個人を識別できる形での提示を行いません。</li>
            <li>当社は、統計情報等の作成・利用にあたり、合理的な範囲で再識別（個人または特定組織の推知を含みます。）のリスク低減に努め、再識別を意図した取扱いを行いません。</li>
        </ol>

        <h2>6. 当社による閲覧・分析（内部利用）</h2>
        <ol>
            <li>当社は、本サービスの提供・運用、保守、サポート対応、品質改善、セキュリティ確保、規約違反対応等に必要な範囲で、利用者データを取り扱います。</li>
            <li>当社は、統計情報等の作成や助言・分析の品質確保（ミスリード防止）に必要な範囲で、非公開情報を除く利用者データについて、利用組織名と紐づけた状態で内部的に閲覧・分析・検証することがあります。</li>
            <li>当社は、利用組織名と利用者データを紐づけた状態の情報を、当該利用組織の事前同意または法令に基づく場合を除き、第三者に提供または公開しません。</li>
        </ol>

        <h2>7. 非公開情報の取扱い（閲覧は許可制）</h2>
        <ol>
            <li>当社は、原則として非公開情報を閲覧しません。</li>
            <li>利用組織は、管理者の設定その他当社所定の方法により、当社に対し、非公開情報の全部または一部の閲覧を許可することができます。</li>
            <li>当社は、前号の許可を得た場合に限り、許可された目的および範囲内で非公開情報を閲覧・利用し、当該許可は利用組織により撤回できます。</li>
        </ol>

        <h2>8. 第三者提供</h2>
        <p>当社は、個人データを、以下の場合を除き第三者に提供しません。</p>
        <ol>
            <li>本人の同意がある場合</li>
            <li>法令に基づく場合</li>
            <li>人の生命、身体または財産の保護のために必要であり、本人の同意を得ることが困難である場合</li>
            <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要であり、本人の同意を得ることが困難である場合</li>
            <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに協力する必要があり、本人の同意により当該事務の遂行に支障を及ぼすおそれがある場合</li>
        </ol>
        <p>なお、統計情報等は個人を識別できない形式で作成されるため、個人データの第三者提供に該当しない範囲で、本ポリシーおよび利用規約に従い利用されることがあります。</p>

        <h2>9. 委託</h2>
        <p>
            当社は、本サービスの提供に必要な範囲で、個人データの取扱いを外部事業者に委託することがあります（例：クラウドインフラ、メール配信、サポートツール、決済代行等）。当社は、委託先の選定にあたり適切な基準で審査し、契約上の義務付け等により必要かつ適切な監督を行います。
        </p>

        <h2>10. 国外移転（国外保存・国外委託の可能性）</h2>
        <p>
            当社が利用するクラウドサービス等の提供事業者のサーバー所在地によっては、個人データが日本国外で保存または処理される場合があります。当社は、当該取扱いが法令上必要となる場合、外国にある第三者への提供に関する情報提供および同意取得等、必要な措置を講じます。
        </p>

        <h2>11. 安全管理措置</h2>
        <p>当社は、個人データの漏えい、滅失または毀損の防止その他の安全管理のため、合理的な措置を講じます。安全管理措置の概要は以下のとおりです（詳細はお問い合わせによりご案内します）。</p>
        <ul>
            <li><strong>組織的安全管理：</strong>取扱い責任者の設置、規程整備、アクセス権限管理、監査・点検</li>
            <li><strong>人的安全管理：</strong>教育・啓発、秘密保持義務の徹底</li>
            <li><strong>物理的安全管理：</strong>入退室管理、端末・媒体管理</li>
            <li><strong>技術的安全管理：</strong>通信の暗号化、認証、アクセスログ管理、脆弱性対応、不正アクセス対策</li>
        </ul>

        <h2>12. 保管期間・契約終了後の取扱い</h2>
        <ol>
            <li>当社は、利用目的の達成に必要な期間、または法令上必要な期間、個人データを保管します。</li>
            <li>利用契約が終了した場合、当社は、法令上の保存義務、料金精算、紛争対応、監査対応、セキュリティ確保その他合理的に必要な場合を除き、非公開情報および添付ファイルについて、当社所定の期間内に削除、利用停止、または識別不能化その他合理的な措置を講じます。</li>
            <li>当社は、第三者の権利侵害、個人情報の不適切な取扱い、営業秘密・機密情報の混入等のおそれがある場合、当該情報を非公開化または削除その他必要な措置を講じることがあります。</li>
            <li>当社は、保管期間経過後または不要となった場合、合理的な方法で消去または匿名化等の処理を行います。</li>
        </ol>

        <h2>13. 開示等の請求</h2>
        <p>
            当社が保有する個人データについて、本人または正当な代理人は、法令に基づき、利用目的の通知、開示、訂正・追加・削除、利用停止・消去、第三者提供停止等を請求できます。当社は、本人確認等の手続を行ったうえで、合理的な範囲で対応します（法令により応じられない場合があります）。
        </p>

        <h2>14. Cookie等の利用</h2>
        <p>
            当社は、本サービスの提供・利便性向上、セキュリティ確保および利用状況分析のため、Cookie等の技術を使用することがあります。利用者は、ブラウザ設定によりCookieの受け入れを拒否できますが、その場合、本サービスの一部機能が利用できないことがあります。
        </p>

        <h2>15. 本ポリシーの変更</h2>
        <p>
            当社は、法令の変更、事業内容の変更等に応じて、本ポリシーを改定することがあります。改定後の内容は、本サービス上への掲示その他当社所定の方法で周知し、周知した時点または別途定める効力発生日から適用されます。
        </p>

        <h2>16. お問い合わせ</h2>
        <p>本ポリシーに関するお問い合わせは、以下までご連絡ください。</p>
        <ul>
            <li><strong>窓口：</strong>合同会社パルグロウ UNION NEST対応窓口</li>
            <li><strong>メール：</strong><a href="mailto:support@palgrow.co.jp">support@palgrow.co.jp</a></li>
            <li><strong>住所：</strong>東京都渋谷区渋谷2丁目19番地15号 宮益坂ビルディング6F</li>
        </ul>

        <p>以上</p>
    </div>
</div>